import firedux from '../firedux'

import {
  GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT,
  GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT
} from '../../config/constants'

export const subscribeGroupChat = (uid, groupId, type) => {
  if (!uid || !groupId || !type) return Promise.reject()

  const userRef = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT)
    .child(type).child(uid).child(groupId)

  const groupRef = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT)
    .child(type).child(groupId).child(uid)

  return userRef.set(true)
    .then(() => groupRef.set(true))
}

export const unsubscribeGroupChat = (uid, groupId, type) => {
  if (!uid || !groupId || !type) return Promise.reject()

  const userRef = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT)
    .child(type).child(uid).child(groupId)

  const groupRef = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT)
    .child(type).child(groupId).child(uid)

  return userRef.remove()
    .then(() => groupRef.remove())
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/group_chat_subscription.js
 **/